import { makeVar } from '@apollo/client';

// possible types 'info' | 'error' |'success'
export const displayNotification = makeVar({ type: 'info', text: '' });
